"use strict";
/* eslint-disable react/prop-types */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SubMenuItemDefinition = exports.SubMenuItem = void 0;
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var MainMenu_1 = require("../modules/MainMenu");
var SidebarPanel_1 = require("../SidebarPanel");
var Sidebar_1 = require("../Sidebar");
var SubMenuItem = function (_a) {
    var path = _a.path, item = _a.item, slim = _a.slim, state = _a.state, dispatch = _a.dispatch, navigate = _a.navigate;
    var isOpen = state.navigationPath.startsWith(path);
    var isActive = isOpen || state.activePath.startsWith(path);
    var depth = path.split('.').length;
    var _b = __read(React.useState(false), 2), isVisible = _b[0], setIsVisible = _b[1];
    React.useEffect(function () {
        if (isOpen) {
            // isOpen is set at the moment the user clicks the menu item
            setIsVisible(true);
        }
        else if (!isOpen && isVisible) {
            // When a submenu is closed, we have to wait for the close animation
            // to finish before making it invisible
            setTimeout(function () {
                setIsVisible(false);
            }, Sidebar_1.SIDEBAR_TRANSITION_DURATION);
        }
    }, [isOpen]);
    var onClick = function (e) {
        if (isOpen) {
            var pathComponents = path.split('.');
            pathComponents.pop();
            var parentPath = pathComponents.join('.');
            dispatch({
                type: 'set-navigation-path',
                path: parentPath,
            });
        }
        else {
            dispatch({
                type: 'set-navigation-path',
                path: path,
            });
        }
        e.preventDefault();
    };
    var className = ('sidebar-menu-item sidebar-sub-menu-item'
        + (isActive ? ' sidebar-menu-item--active' : '')
        + (isOpen ? ' sidebar-sub-menu-item--open' : ''));
    var sidebarTriggerIconClassName = ('sidebar-sub-menu-trigger-icon'
        + (isOpen ? ' sidebar-sub-menu-trigger-icon--open' : ''));
    return (React.createElement("li", { className: className },
        React.createElement("button", { onClick: onClick, className: "sidebar-menu-item__link " + item.classNames, "aria-haspopup": "true", "aria-expanded": isOpen ? 'true' : 'false' },
            item.iconName && React.createElement(Icon_1["default"], { name: item.iconName, className: "icon--menuitem" }),
            React.createElement("span", { className: "menuitem-label" }, item.label),
            React.createElement(Icon_1["default"], { className: sidebarTriggerIconClassName, name: "arrow-right" })),
        React.createElement(SidebarPanel_1.SidebarPanel, { isVisible: isVisible, isOpen: isOpen, depth: depth },
            React.createElement("div", { className: "sidebar-sub-menu-panel" },
                React.createElement("h2", { id: "wagtail-sidebar-submenu" + path.split('.').join('-') + "-title", className: item.classNames },
                    item.iconName && React.createElement(Icon_1["default"], { name: item.iconName, className: "icon--submenu-header" }),
                    item.label),
                React.createElement("ul", { "aria-labelledby": "wagtail-sidebar-submenu" + path.split('.').join('-') + "-title" }, MainMenu_1.renderMenu(path, item.menuItems, slim, state, dispatch, navigate)),
                item.footerText && React.createElement("p", { className: "sidebar-sub-menu-panel__footer" }, item.footerText)))));
};
exports.SubMenuItem = SubMenuItem;
var SubMenuItemDefinition = /** @class */ (function () {
    function SubMenuItemDefinition(_a, menuItems) {
        var name = _a.name, label = _a.label, _b = _a.icon_name, iconName = _b === void 0 ? null : _b, _c = _a.classnames, classnames = _c === void 0 ? undefined : _c, _d = _a.footer_text, footerText = _d === void 0 ? '' : _d;
        this.name = name;
        this.label = label;
        this.menuItems = menuItems;
        this.iconName = iconName;
        this.classNames = classnames;
        this.footerText = footerText;
    }
    SubMenuItemDefinition.prototype.render = function (_a) {
        var path = _a.path, slim = _a.slim, state = _a.state, dispatch = _a.dispatch, navigate = _a.navigate;
        return (React.createElement(exports.SubMenuItem, { key: this.name, item: this, path: path, slim: slim, state: state, dispatch: dispatch, navigate: navigate }));
    };
    return SubMenuItemDefinition;
}());
exports.SubMenuItemDefinition = SubMenuItemDefinition;
